import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function PaymentSuccess() {
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading"); // "loading" | "succeeded" | "failed"

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const redirectStatus = params.get("redirect_status");
    if (redirectStatus === "succeeded") {
      setStatus("succeeded");
    } else {
      setStatus("failed");
    }
  }, []);

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        {status === "loading" && (
          <p style={styles.sub}>Bekrefter betaling...</p>
        )}

        {status === "succeeded" && (
          <>
            <div style={styles.iconWrap}>
              <svg
                width='40'
                height='40'
                viewBox='0 0 24 24'
                fill='none'
                stroke='#E05A3A'
                strokeWidth='2.5'
                aria-hidden='true'>
                <path d='M22 11.08V12a10 10 0 1 1-5.93-9.14' />
                <polyline points='22 4 12 14.01 9 11.01' />
              </svg>
            </div>
            <h1 style={styles.title}>Betaling bekreftet!</h1>
            <p style={styles.sub}>
              Promotering av arrangementet ditt er nå aktivt.
            </p>
            <button
              style={styles.btn}
              onClick={() => navigate("/MyBusiness/events")}>
              Tilbake til forsiden
            </button>
          </>
        )}

        {status === "failed" && (
          <>
            <div style={{ ...styles.iconWrap, background: "#fef3ee" }}>
              <svg
                width='40'
                height='40'
                viewBox='0 0 24 24'
                fill='none'
                stroke='#E05A3A'
                strokeWidth='2.5'
                aria-hidden='true'>
                <circle cx='12' cy='12' r='10' />
                <line x1='15' y1='9' x2='9' y2='15' />
                <line x1='9' y1='9' x2='15' y2='15' />
              </svg>
            </div>
            <h1 style={styles.title}>Noe gikk galt</h1>
            <p style={styles.sub}>
              Betalingen ble ikke gjennomført. Ingen beløp er trukket.
            </p>
            <button style={styles.btn} onClick={() => navigate(-1)}>
              Prøv igjen
            </button>
          </>
        )}
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#f7f5f0",
    padding: "1rem",
    fontFamily: "'DM Sans', sans-serif",
  },
  card: {
    background: "#fff",
    borderRadius: "16px",
    padding: "2.5rem 2rem",
    maxWidth: "420px",
    width: "100%",
    textAlign: "center",
    boxShadow: "0 4px 24px rgba(0,0,0,0.07)",
  },
  iconWrap: {
    width: "72px",
    height: "72px",
    borderRadius: "50%",
    background: "#fef3ee",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto 1.5rem",
  },
  title: {
    fontSize: "22px",
    fontWeight: 700,
    color: "#1a1a1a",
    margin: "0 0 0.75rem",
  },
  sub: {
    fontSize: "15px",
    color: "#666",
    lineHeight: 1.6,
    margin: "0 0 1.75rem",
  },
  btn: {
    background: "#E05A3A",
    color: "#fff",
    border: "none",
    borderRadius: "30px",
    padding: "12px 32px",
    fontSize: "15px",
    fontWeight: 600,
    cursor: "pointer",
    fontFamily: "'DM Sans', sans-serif",
  },
};
